import { Avatar, Badge, Typography } from "@mui/material";
import { Box } from "@mui/system";

interface IProps {
  onClick: () => void;
  isActive: boolean;
  data: {
    sent_time: string;
    ticket_id: number;
    title: string;
    unread_ticket: boolean;
    user_avatar: string;
    user_name: string;
  };
}

export default function TicketItem({ onClick, data, isActive }: IProps) {

  return (
    <Box onClick={onClick} sx={{
      transition: "background-color 0.2s",
      display: "flex", justifyContent: "space-between",
      alignItems: "flex-start",
      p: 1.5,
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#f3f3f3",
        transition: "background-color 0.2s",
      },
      ...(isActive ? {
        backgroundColor: "#f3f3f3",
        transition: "background-color 0.2s",
        borderLeft: "3px solid #00FFFF",
      } : {})
    }}>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Avatar
          alt={data.user_name}
          src={data.user_avatar}
          sx={{
            width: "35px",
            height: "35px",
          }}
        />
        <Box sx={{ width: "120px" }}>
          <Typography variant="subtitle2" sx={{ fontSize: "11px" }}>
            {data.unread_ticket && <Badge color="info" variant="dot" sx={{ marginInlineEnd: "10px" }} />}
            {data.user_name}
          </Typography>
          <Typography variant="subtitle1" sx={{
            fontSize: "10px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            maxWidth: "119px",
            textOverflow: "ellipsis",
          }}>
            {data.title}
          </Typography>
        </Box>
      </Box>

      <Box>
        <Typography variant="subtitle2" sx={{ fontSize: "10px" }}>
          {data.sent_time}
        </Typography>
      </Box>

    </Box>
  )
}